import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
    // Check if user prefers reduced motion for EAA compliance
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
        return;
    }

    const titles = gsap.utils.toArray('.moving-title');
    titles.forEach((title) => {
        gsap.from(title, {
            scrollTrigger: {
                trigger: title,
                start: 'top 90%',
                toggleActions: 'play none none none',
            },
            x: 50,
            opacity: 0,
            duration: 1,
            stagger: 0.2,
            ease: 'power2.out',
        });
    });

    const images = gsap.utils.toArray('.revealing-image');

    images.forEach((image) => {
        gsap.from(image, {
            scrollTrigger: {
                trigger: image,
                start: 'top 75%',
                toggleActions: 'play none none none',
            },
            x: 100,
            opacity: 0,
            duration: 1,
            ease: 'power2.out',
        });
    });

    const imagesLeftEffect = gsap.utils.toArray('.revealing-image-left');

    imagesLeftEffect.forEach((image) => {
        gsap.from(image, {
            scrollTrigger: {
                trigger: image,
                start: 'top 75%',
                toggleActions: 'play none none none',
            },
            x: -100,
            opacity: 0,
            duration: 1,
            ease: 'power2.out',
        });
    });

    gsap.utils.toArray('.parallax-element').forEach((el) => {
        gsap.fromTo(el,
            {
                yPercent: 0,
            },
            {
                yPercent: 20,
                ease: 'none',
                scrollTrigger: {
                    trigger: el,
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true,
                },
            });
    });
});
